import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-triangle-right"} maskId="square-filled-radius-0-stroke-1-IconArrowTriangleRight"><path d="M4 3.69141V20.3094L20.618 12.0004L4 3.69141Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowTriangleRight;
